module.exports = __webpack_public_path__ + "img/files.3567d576.svg";